import { render } from "./Chat-user.vue?vue&type=template&id=3f5a2bc4&scoped=true&lang=pug"
import script from "./Chat-user.vue?vue&type=script&setup=true&lang=js"
export * from "./Chat-user.vue?vue&type=script&setup=true&lang=js"

import "./Chat-user.vue?vue&type=style&index=0&id=3f5a2bc4&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a2bc4"]])

export default __exports__